import { useMemo, useState } from "react"

import { FilterButton } from "@l2r-front/l2r-ui"

import { FILTERS } from "../../constants/filters"
import { useRoadworksStateContext } from "../../contexts/RoadworksContext/RoadworksContext.hooks"
import { roadworksFiltersConfig } from "../../utils/roadworksFiltersConfig"

import { TechniquesFilters } from "../TechniquesFilters"

export function RoadworksFilterButton(props: RoadworksFilterButtonProps) {

    const {
        className,
        enabledFilters = FILTERS,
    } = props

    const [displayFilters, setDisplayFilters] = useState(false)
    const closeFilters = () => setDisplayFilters(false)
    const toggleFilter = () => setDisplayFilters(displayFilters => !displayFilters)

    const { filters } = useRoadworksStateContext()

    type RoadworksFilterKey = keyof typeof roadworksFiltersConfig;

    const filterCount = useMemo(() => {
        return Object.entries(filters || {}).map(([filterKey, filterValue]) => {
            if (enabledFilters.includes(filterKey as RoadworksFilterKey)) {
                return roadworksFiltersConfig?.[filterKey as RoadworksFilterKey]?.getValueList(filterKey, filterValue)
            } else {
                return []
            }
        }).flat().length
    }, [filters, enabledFilters])

    return <FilterButton className={className} filterCount={filterCount} open={displayFilters} onClick={toggleFilter} onClose={closeFilters}>
        <TechniquesFilters close={closeFilters} displayFilters={displayFilters} />
    </FilterButton>
}

type RoadworksFilterButtonProps = {
    className?: string
    enabledFilters?: Array<typeof FILTERS[number]>
}
